import { UseQueryResult } from 'react-query';
import { useMyQuery, QueryInfos, Options } from '../helpers';
import { GetPaymentCardsInput, GetPaymentGroupSettingsInput, GetVouchersInput } from '../../apiTypes';
import { typePayments } from './types';

const cardsQuery = (variables: GetPaymentCardsInput): QueryInfos => {
    return {
        name: 'cards',
        path: '/payment-methods/cards',
        type: typePayments.GET_CARDS,
        params: {
            ...variables,
        },
    };
};

const groupSettingsQuery = (variables: GetPaymentGroupSettingsInput): QueryInfos => {
    return {
        name: 'group-settings',
        path: '/payment-methods/settings',
        type: typePayments.GET_GROUP_SETTINGS,
        params: {
            ...variables,
        },
    };
};

const vouchersQuery = (variables: GetVouchersInput): QueryInfos => {
    return {
        name: 'vouchers',
        path: '/payment-methods/vouchers',
        type: typePayments.GET_VOUCHERS,
        params: {
            ...variables,
        },
    };
};

export function useGetVouchers<T>(options: Options<GetVouchersInput>): UseQueryResult<T, Error> {
    return useMyQuery<T, GetVouchersInput>(vouchersQuery, { ...options, select: (data) => data.vouchers });
}

export function useGetPaymentCards<T>(options: Options<GetPaymentCardsInput>): UseQueryResult<T, Error> {
    return useMyQuery<T, GetPaymentCardsInput>(cardsQuery, { ...options, select: (data) => data.data });
}

export function useGetPaymentGroupSettings<T>(
    options: Options<GetPaymentGroupSettingsInput>,
): UseQueryResult<T, Error> {
    return useMyQuery<T, GetPaymentGroupSettingsInput>(groupSettingsQuery, {
        ...options,
        select: (data) => data.group_payment_policies,
    });
}

export function useGetPaymentGroupSettingsForContract<T>(
    options: Options<GetPaymentGroupSettingsInput>,
): UseQueryResult<T, Error> {
    return useMyQuery<T, GetPaymentGroupSettingsInput>(groupSettingsQuery, { ...options });
}
